import { formatUrl } from '@plone/volto/helpers/Api/Api';
import { addAppURL, flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import { isPloneContentUrl, normalizeAppUrl } from './appUrl';

export const BATCH_SIZE = 24;

export const normalizeMediaUrl = (url) => {
  if (!url) {
    return '';
  }

  if (url.startsWith('http://') || url.startsWith('https://')) {
    if (isPloneContentUrl(url)) {
      try {
        const parsed = new URL(url);
        let path = parsed.pathname || '/';
        if (path.startsWith('/Plone')) {
          path = path.slice('/Plone'.length) || '/';
        }
        return formatUrl(path);
      } catch {
        return url;
      }
    }
    return url;
  }

  return addAppURL(flattenToAppURL(url));
};

const normalizeImageUrl = (download) => normalizeMediaUrl(download);

const imageUrlFromItemId = (item) => {
  if (!item?.['@id'] || !item?.image_field) {
    return '';
  }
  return normalizeMediaUrl(`${normalizeAppUrl(item['@id'])}/@@images/image`);
};

export const getLeadImageUrl = (item, scale = 'large') => {
  const image = item?.image;

  if (image) {
    const scales = image.scales || {};
    let download;

    if (scale === 'original') {
      download =
        image.download ||
        scales.great?.download ||
        scales.huge?.download ||
        scales.larger?.download ||
        scales.large?.download;
    } else {
      download =
        scales[scale]?.download ||
        scales.large?.download ||
        scales.preview?.download ||
        image.download;
    }

    const normalized = normalizeImageUrl(download);
    if (normalized) {
      return normalized;
    }
  }

  if (item?.image_field && item?.['@id']) {
    return imageUrlFromItemId(item);
  }

  return '';
};

export const getBlogPageUrl = (contentId, page, batchSize = BATCH_SIZE) => {
  const batchStart = (page - 1) * batchSize;
  const path = `${normalizeAppUrl(contentId)}?fullobjects&b_start=${batchStart}&b_size=${batchSize}`;
  return formatUrl(path);
};

export const computePaginationPages = (itemsTotal, batchSize = BATCH_SIZE) => {
  if (!itemsTotal || itemsTotal <= batchSize) {
    return 1;
  }
  return Math.ceil(itemsTotal / batchSize);
};

export const isProfessionalTag = (item) =>
  (item?.subjects || []).some((tag) =>
    ['professional', 'professionals'].includes(String(tag).toLowerCase()),
  );
